// @flow

class EventBinder {
	eventTarget: ?Element;
	binders: {[key: string]: Array<any => void>} = Object.create(null);

	addBinding(event: string, fn: any => void) {
		const bindings = this.binders[event] = this.binders[event] || [];
		bindings.push(fn);
		const {eventTarget} = this;
		if (eventTarget) {
			eventTarget.addEventListener(event, fn);
		}
	}

	removeBinding(event: string, fn: any => void) {
		const bindings = this.binders[event] = this.binders[event] || [];
		const index = bindings.indexOf(fn);
		~index && bindings.splice(index, 1);
		const {eventTarget} = this;
		if (eventTarget) {
			eventTarget.removeEventListener(event, fn);
		}
	}

	eachBinding(eachFn: (string, any => void) => void) {
		const keys = Object.keys(this.binders);
		for (let i = 0; i < keys.length; i++) {
			const key = keys[i];
			for (let i = 0; i < this.binders[key].length; i++) {
				const fn = this.binders[key][i];
				eachFn(key, fn);
			}
		}
	}

	setEventTarget(target: ?Element) {
		const {eventTarget} = this;
		if (target === eventTarget) { return; }
		if (eventTarget) {
			this.eachBinding((event, fn) => eventTarget.removeEventListener(event, fn));
		}
		this.eventTarget = target;
		if (target) {
			const _target = target; // FU flow!
			this.eachBinding((event, fn) => _target.addEventListener(event, fn));
		}
	}
}

export default EventBinder;



// WEBPACK FOOTER //
// ./lib/scroller/events.js